import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import styled from 'styled-components'
import { SceneHeader, KTCodeExample, SceneDropDown } from "../controls";
import SceneDropDownAction from '../../../_metronic/_partials/controls/SceneDropDownAction'
import { Badge, Row, Col, Accordion, Card, FormControl, Container } from 'react-bootstrap'
import { SubHeader } from "../../layout/components/subheader/SubHeader";
import SceneDragItem from './SceneDragItem'
import { layoutUpdate, CREATE_SCENE, UPDATE_SCENE_STATUS } from '../../../../../../../actions/sceneActions'
import { getInitialRoute, loaderCircleStyle, secondsToTime } from '../../../../../../../utils'
import Item from './item'
import { DISPLAY_WALL_SUCCESS_SAVE, SUCCESS_TEXT } from '../../../app/messageText'

const circleStyle = loaderCircleStyle;

class LayoutPage extends Component {
    state = {
        intial: 10,
        duration: secondsToTime(0),
        isFocused: false,
        newLayout: {},
        scenes: []
    }
    componentDidMount() { 
        const { scenes, layouts } = this.props;
        //this.onLoadCreateScene();
        this.setState({ scenes })
    }
    // onLoadCreateScene = () => {
    //     const { scenes, layouts } = this.props;
    //     if (layouts && layouts.length > 0) {
    //         const selectedLayout = layouts[0];
    //         const { match } = this.props;
    //         if (selectedLayout && selectedLayout.id) {
    //             this.setState({ newLayout: selectedLayout }, () => this.props.CREATE_SCENE(selectedLayout.id, match.params.wallId, () => {
    //                 if (document.getElementById("kt_aside_menu")) {
    //                     var elmnt = document.getElementById("kt_aside_menu");
    //                     if (elmnt.scrollHeight) elmnt.scrollTo(0, elmnt.scrollHeight);
    //                 }

    //             }))
    //         }
    //     }
    // }

    onIncreaseTime = event => {
        const { intial } = this.state;
        this.setState({ intial: (intial + 1), duration: secondsToTime((intial + 1)) })
    }
    onDecreaseTime = event => {
        const { intial } = this.state;
        this.setState({ intial: (intial - 1), duration: secondsToTime((intial - 1)) })
    }
    onCreateNewLayout = (layoutID) => event => {
        const { match, params } = this.props;
        //this.props.CREATE_SCENE(layoutID, match.params.wallId, this.onSaveCallBack);
        this.props.layoutUpdate(layoutID)
        toast.success("Scene layout has been successfully saved !", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        this.props.history(`/studio/${match.params.wallId}`)
    }
    onSaveCallBack = () => {
        const { params } = this.props.match;
        Swal.fire({
            title: SUCCESS_TEXT,
            text: DISPLAY_WALL_SUCCESS_SAVE,
            type: "success",
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
        }
        ).then((result) => {
            this.props.history(`/studio/${params.wallId}`)
        })
    }

    callbackScene=(sceneID)=>{ 

        const { match, scenes, studio} =this.props;
        const totalTime =scenes.scenes.filter(obj=> obj['totalTime']>0 && obj['id']!=sceneID && obj['status']==1)
       
        if((scenes.scenes.length==1 || !totalTime.length) && studio.studioWall.is_studio_enabled){
            this.props.UPDATE_STATUS(false,match.params.wallId)
          }

        setTimeout(() => this.setState({ anchorEl: null }), 1000)
    }

    onUpdateSceneStatus = (sceneContentId, status) => event => {
        this.props.UPDATE_SCENE_STATUS(sceneContentId, status, ()=>this.callbackScene(sceneContentId));
    }
    componentWillReceiveProps(nextProps) {
        const { newLayout } = this.state;
        const { scenes } = nextProps;
        //if (newLayout && Object.keys(newLayout).length == 0) this.onLoadCreateScene();
        this.setState({ scenes })
    }

    render() {
        const { layouts, history, params } = this.props;
        const { duration, isFocused, newLayout, scenes } = this.state;
        // if (params && params.wallId && newLayout && Object.keys(newLayout).length == 0) history.push(`/studio/${params.wallId}`)


        return <>{(Object.keys(scenes).length > 0 && scenes.scenes && scenes.scenes.length > 0 && <div className="mt-5">
            <SubHeader />

            <div className="container-fluid select_layout subheader_content">
                <SceneHeader icon="flaticon-warning font-primary" name={scenes.scenes[scenes.defaultScene].name}>
                    <Row>
                        <Col className="justify-content-start d-flex">
                            <div className="d-flex align-items-center">
                                <div className="screen_title">
                                    <h4 className="m-0 mr-4">{scenes.scenes[scenes.defaultScene].name}</h4>
                                </div>
                                <SceneDropDown activeScene={scenes.scenes[scenes.defaultScene]} layoutUpdate={this.props.layoutUpdate} />
                            </div>
                        </Col>
                        <Col className="justify-content-center d-flex align-items-center">
                            <span className="label label-xxl label-inline label-dark-50 font-size-h5">{secondsToTime(0)}</span>
                        </Col>
                        <Col className="justify-content-end d-flex align-items-center">
                            <SceneDropDownAction circleStyle={circleStyle} onUpdateSceneStatus={this.onUpdateSceneStatus} status={scenes.scenes[scenes.defaultScene].status} sceneContentId={scenes.scenes[scenes.defaultScene].id} {...this.props} />
                        </Col>
                    </Row>
                </SceneHeader>
                <div className="p-6">
                    <div className="scene-card-body mb-3">
                        <div className="d-flex align-items-center justify-content-center">
                            <Container>
                                <div className="layout_card_wrap w-100">
                                    <div className="border-0 text-center p-0">
                                        <h3 className="text-center font-weight-normal mb-5 mb-lg-8">Choose Scene Layout</h3>
                                    </div>
                                    <div className="select_layout_">
                                        <Item layouts={layouts} onCreateNewLayout={this.onCreateNewLayout} />
                                    </div>
                                </div>
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </div >)}

        </>
    }
}
const mapStateToProps = state => {
    return {
        scenes: state.scene,
        layouts: state.layout.layouts
    }
}
const mapDispatchToProps = dispatch => {
    return {
        layoutUpdate: (layoutID) => dispatch(layoutUpdate(layoutID)),
        CREATE_SCENE: (layoutID, wallId, callBack) => dispatch(CREATE_SCENE(layoutID, wallId, callBack)),
        UPDATE_SCENE_STATUS: (sceneContentId, status, callbackScene) => dispatch(UPDATE_SCENE_STATUS(sceneContentId, status, callbackScene)),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LayoutPage);